export default "__VITE_ASSET__bW9xkhkH__"